import {
  hasAbsAccess,
  hasCustomerJourneyPlan,
  hasFullIntelligencePlan,
  hasMarketIntelligencePlan,
  hasProduct,
  hasSonicProspectPlan,
  hasVoiceOfCustomerPlan,
  PLAN_ACCESS,
  PRODUCT,
  sonicEngageAccess,
  surveyAccess,
} from "./entitlements";

export const PRODUCT_LOCK = {
  voice_of_customer: {
    i18nKey: "voc_lock",
    productUrl: "https://pivony.com/products/voc",
    mailSubject: "Voice%20of%20Customer%20plan",
    signupKey: "voice_of_customer",
    mode: "sales",
  },
  customer_365: {
    i18nKey: "customer_365_lock",
    productUrl: "https://pivony.com/products/customer-365",
    mailSubject: "Customer%20365",
    signupKey: "customer_365",
    mode: "sales",
  },
  advanced_behavioral_segmentation: {
    i18nKey: "abs_lock",
    productUrl: "https://pivony.com/micro-segmentation",
    mailSubject: "Micro-Segments",
    signupKey: "advanced_behavioral_segmentation",
    mode: "sales",
  },
  customer_journey: {
    i18nKey: "customer_journey_lock",
    productUrl: "https://pivony.com/customer-journey",
    mailSubject: "Customer%20Journey%20Add-on",
    signupKey: "customer_journey",
    mode: "sales",
  },
  market_intelligence: {
    i18nKey: "market_intelligence_lock",
    productUrl: "https://pivony.com/products/market-intelligence",
    mailSubject: "Market%20Intelligence%20Plan",
    signupKey: "market_intelligence",
    mode: "sales",
  },
  sonic_engage: {
    i18nKey: "sonic_lock",
    productUrl: "https://pivony.com/products/engage",
    mailSubject: "Pivony%20Sonic%20Activation",
    signupKey: "sonic",
    mode: "sales",
  },
  sonic_prospect: {
    i18nKey: "sonic_prospect_lock",
    productUrl: "https://pivony.com/products/sonic-prospect",
    mailSubject: "Sonic%20Prospect%20Activation",
    signupKey: "sonic_prospect",
    mode: "freemium",
  },
  survey: {
    i18nKey: "survey_lock",
    productUrl: "https://pivony.com/products/pivony-survey",
    mailSubject: "Pivony%20Survey",
    signupKey: "survey",
    mode: "freemium",
  },
  teach_ai: {
    i18nKey: "teach_ai_lock",
    productUrl: "https://pivony.com/book-a-demo",
    mailSubject: "Teach%20the%20AI",
    signupKey: null,
    mode: "sales",
  },
  advisor: {
    i18nKey: "advisor_lock",
    productUrl: "https://pivony.com/products/sonic-advisor",
    mailSubject: "Sonic%20Advisor",
    signupKey: "advisor",
    mode: "freemium",
  },
};

export function hasCustomer365Access(subscriptionRow) {
  return (
    hasProduct(subscriptionRow, PRODUCT.CUSTOMER_365) ||
    hasVoiceOfCustomerPlan(subscriptionRow) ||
    hasFullIntelligencePlan(subscriptionRow)
  );
}

export function hasVocCoreAccess(subscriptionRow) {
  return (
    hasVoiceOfCustomerPlan(subscriptionRow) ||
    hasFullIntelligencePlan(subscriptionRow)
  );
}

export function resolveConsoleProductLock(pathname) {
  const p = String(pathname || "").replace(/\/$/, "") || "/";
  if (!p.startsWith("/console")) return null;
  if (p.startsWith("/console/customer-365")) return "customer_365";
  if (p.startsWith("/console/behavioral-segmentation")) {
    return "advanced_behavioral_segmentation";
  }
  if (p === "/console/advisor") return "advisor";
  if (p.startsWith("/console/journeys") || p.startsWith("/console/journey")) {
    return "customer_journey";
  }
  if (p.startsWith("/console/industryTopics")) return "market_intelligence";
  if (p.startsWith("/console/sonic-prospect")) return "sonic_prospect";
  // Before the /console/sonic check below: /console/sonic-survey is Sonic Survey, not Engage.
  if (
    p.startsWith("/console/sonic-survey") ||
    p.startsWith("/console/feedback-capture") ||
    p.startsWith("/console/surveys")
  ) {
    return "survey";
  }
  if (
    p.startsWith("/console/sonic") ||
    p.startsWith("/console/whatsapp") ||
    p.startsWith("/console/pivony-sonic") ||
    p.startsWith("/console/advisor-voice")
  ) {
    return "sonic_engage";
  }
  return null;
}

export function hasProductLockAccess(productKey, subscriptionRow, extras = {}) {
  switch (productKey) {
    case "advisor":
      return extras.hasAdvisorAccess === true;
    case "customer_365":
      return hasCustomer365Access(subscriptionRow);
    case "advanced_behavioral_segmentation":
      return hasAbsAccess(subscriptionRow);
    case "customer_journey":
      return hasCustomerJourneyPlan(subscriptionRow);
    case "market_intelligence":
      return hasMarketIntelligencePlan(subscriptionRow);
    case "sonic_engage":
      // A plan that has ended still opens read-only.
      return sonicEngageAccess(subscriptionRow) !== PLAN_ACCESS.NONE;
    case "sonic_prospect":
      return hasSonicProspectPlan(subscriptionRow);
    case "survey":
      return surveyAccess(subscriptionRow) !== PLAN_ACCESS.NONE;
    case "voice_of_customer":
      return hasVocCoreAccess(subscriptionRow);
    default:
      return true;
  }
}
